import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StaffLoginService } from '../services/staff-login/staff-login.service';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {
  // Region-wise testimonials
  testimonialsByRegion = {
    INDIA: [
      {
        index: 0,
        name: 'Srinivas G',
        designation: 'Sr. HR Manager, Tata 1mg',
        company: 'Tata 1mg',
        logo: 'assets/company_logos/Tata 1mg.png',
        profile_pic: 'assets/profile-photos/Srinivas G.png',
        feedback: "Moving from thumb-based attendance system to a Face recognition based time and attendance solution was made easy by the Truein team."
      },
      {
        index: 1,
        name: 'Girish Nimbalkar',
        designation: 'AGM HR, SJ Contracts',
        company: 'SJ Contracts',
        logo: 'assets/company_logos/SJ Contracts.png',
        profile_pic: 'assets/profile-photos/Girish Nimbalkar.png',
        feedback: "We are using Truein Time and Attendance system at our 80 sites for over 10,000 staff. Truein has built-in customization options and gives multiple real-time reports."
      },
      {
        index: 2,
        name: 'Piyush Dutt',
        designation: 'CPO, Compass Group',
        company: 'Compass Group',
        logo: 'assets/company_logos/compass-logo.webp',
        profile_pic: 'assets/profile-photos/Piyush Dutt.png',
        feedback: "Truein is robust, reliable, and works as promised. I have implemented Truein in my previous and current companies. It's the best and most cost-effective solution."
      },
      {
        index: 3,
        name: 'Sujit Pawar',
        designation: 'DGM, OCS Group',
        company: 'OCS Group',
        logo: 'assets/company_logos/OCS-logo.webp',
        profile_pic: 'assets/profile-photos/sujit-pawar.webp',
        feedback: "Truein is a highly accurate, multipurpose, and user-friendly solution. It detects fake clock-ins and covers all the modules."
      },
    ],
    GCC: [
      {
        index: 0,
        name: 'Muhammad Bashir',
        designation: 'Digital Transformation Manager, Group AMANA',
        company: 'Group AMANA',
        logo: 'assets/company_logos/amana logo.png',
        profile_pic: 'assets/profile-photos/muhammad-bashir.webp',
        feedback: "Truein is more than a timekeeping tool. It is an enabler of efficiency, transparency, and data-driven decision-making."
      },
      {
        index: 1,
        name: 'Hadi Hassan Khan',
        designation: 'AZ Engineers & Partners L.L.C., Oman',
        company: 'AZ Engineers & Partners L.L.C.',
        logo: 'assets/company_logos/az_engineers.webp',
        profile_pic: 'assets/profile-photos/Hadi-hassan-khan.webp',
        feedback: "We have had a very positive experience using Truein, and we are pleased to recommend it."
      },
      {
        index: 2,
        name: 'Sridher Mothukuri',
        designation: 'Almoayyed Contracting Group, Bahrain',
        company: 'Almoayyed Contracting Group',
        logo: 'assets/company_logos/almoayyed.png',
        profile_pic: 'assets/profile-photos/sridher-mothukeri.webp',
        feedback: "Because of Truein, proxy attendance has completely stopped, and it saves us a lot of time during payroll."
      },
      {
        index: 3,
        name: 'Wajahat Khan',
        designation: 'Payroll Admin, Al Magamsi General Contracting',
        company: 'Al Magamsi General Contracting',
        logo: 'assets/company_logos/Al Magamsi General Contracting.png',
        profile_pic: 'assets/profile-photos/Wajahat Khan.png',
        feedback: "This face detection time & attendance software is very effective at our construction company. Full marks to Truein and their support team!"
      },
    ],
    ROW: [
      {
        index: 0,
        name: 'Judith Hotek',
        designation: 'Senior IT Admin, Walker Engineering',
        company: 'Walker Engineering',
        logo: 'assets/company_logos/walker.png',
        profile_pic: 'assets/profile-photos/judith-hotek.webp',
        feedback: "Our guys in the field like it. And in the back office, we're loving it as well. So, we would definitely recommend Truein."
      },
      {
        index: 1,
        name: 'Carlos Woodson',
        designation: 'Phoenix Transload Services',
        company: 'Phoenix Transload Services',
        logo: 'assets/company_logos/Phoenix Transload Services.png',
        profile_pic: 'assets/profile-photos/Carlos Woodson.png',
        feedback: "Truein outshines all other time and attendance solutions. Its rich features, payroll ready timesheets and centralized controls put it in a class above all."
      },
      {
        index: 2,
        name: 'Nicolous Noble',
        designation: 'Payroll Administrator, Backerhaus Veit',
        company: 'Backerhaus Veit',
        logo: 'assets/company_logos/Backerhaus.png',
        profile_pic: 'assets/profile-photos/Nicolous Noble.png',
        feedback: "Truein is a perfect solution for tracking time of our temp workers. It has Excellent support and user-friendly system."
      },
      {
        index: 3,
        name: 'Henry Carrillo',
        designation: 'Farm Administrator, Unispice',
        company: 'Unispice',
        logo: 'assets/company_logos/Unispice.png',
        profile_pic: 'assets/profile-photos/Henry Carrillo.png',
        feedback: "Truein has strengthened our Time & Attendance accuracy and quality, ensuring compliance and trust among end-users. Excellent product!"
      },
    ]
  };

  // Region-wise client logos
  clientLogosByRegion = {
    INDIA: [
      'assets/company_logos/compass-logo.webp',
      'assets/company_logos/SJ Contracts.png',
      'assets/company_logos/tata-projects.webp',
      'assets/company_logos/Adani logo.png',
      'assets/company_logos/URC logo.png',
      'assets/company_logos/cbre.webp',
      'assets/company_logos/Lenskart.png',
      'assets/company_logos/Air India logo.png',
    ],
    GCC: [
      'assets/company_logos/amana logo.png',
      'assets/company_logos/az_engineers.webp',
      'assets/company_logos/kad.png',
      'assets/company_logos/kaefer.webp',
      'assets/company_logos/enova.png',
      'assets/company_logos/assiyana.webp',
      'assets/company_logos/Jumia.png',
      'assets/company_logos/Reyada.png',
    ],
    ROW: [
      'assets/company_logos/walker.png',
      'assets/company_logos/d-ambra.webp',
      'assets/company_logos/formcrete.webp',
      'assets/company_logos/sunbelt-asphalt.webp',
      'assets/company_logos/hallmark logo.png',
      'assets/company_logos/mpl_construction.webp',
      'assets/company_logos/Unispice.png',
      'assets/company_logos/america-piping-inspection.webp',
    ]
  };

  // Current testimonials and logos (will be updated based on region)
  testimonials = this.testimonialsByRegion.ROW;
  client_logos = this.clientLogosByRegion.ROW;

  is_websignup: boolean = false;
  params: any;

  // selected_testimonial = this.testimonials[0];
  testimonial_interval;

  slideInterval: any;
  selectedSliderIndex: number = 0;

  current_url: string;
  private onDestroy = new Subject<void>();

  is_signup_loading: boolean = false;
  current_date = new Date();

  constructor(
    private router: Router,
    private staffLoginService: StaffLoginService,
    private route: ActivatedRoute
  ) {
    router.events.pipe(takeUntil(this.onDestroy)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.current_url = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
    this.staffLoginService.signUpView.pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.is_websignup = value == 'web_signup' && (this.current_url.includes('/signup') || this.current_url.includes('/setup'));
    });
    this.staffLoginService.isTrialSignupLoading.pipe(takeUntil(this.onDestroy)).subscribe(value => {
      this.is_signup_loading = value;
    });

    // Subscribe to region changes and update testimonials and logos
    this.staffLoginService.userRegion.pipe(takeUntil(this.onDestroy)).subscribe(region => {
      this.updateContentByRegion(region);
    });

    this.showSlides();
  }

  showSlides() {
    this.slideInterval = setInterval(() => {
      this.selectedSliderIndex++;
      if (this.selectedSliderIndex >= this.testimonials.length) {
        this.selectedSliderIndex = 0;
      }
    }, 5000);
  }

  stopTestimonialSlide() {
    clearInterval(this.slideInterval);
  }

  slideTestimonial(index) {
    this.selectedSliderIndex = index;

    // if (slide_type == 'next') {
    //   if (this.selectedSliderIndex >= 2) {
    //     this.selectedSliderIndex = 0;
    //   } else {
    //     this.selectedSliderIndex++;
    //   };
    // } else {
    //   if (this.selectedSliderIndex == 0) {
    //     this.selectedSliderIndex = 3;
    //   } else {
    //     this.selectedSliderIndex--;
    //   };
    // };
  }

  updateContentByRegion(region: string) {
    // Update testimonials based on region
    if (this.testimonialsByRegion[region]) {
      this.testimonials = this.testimonialsByRegion[region];
    } else {
      this.testimonials = this.testimonialsByRegion.ROW;
    }

    // Update client logos based on region
    if (this.clientLogosByRegion[region]) {
      this.client_logos = this.clientLogosByRegion[region];
    } else {
      this.client_logos = this.clientLogosByRegion.ROW;
    }

    // Reset slider index when content changes
    this.selectedSliderIndex = 0;
  }

  redirectToLogin() {
    window.open(`${environment.base_url}/account/login`, '_self');
  }

  onLogOut(){
    window.open(`${environment.base_url}/logout.php`, '_self');
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

  ngOnDestroy() {
    if (this.testimonial_interval) {
      clearInterval(this.testimonial_interval);
    }
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
